import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = { size: 10 };

const set = (_, { payload }) => payload.page ?? {};

export default createReducer(initialState, {
  [actionTypes.FETCH_MESSAGES_SUCCESS]: set,
});
